import { notification } from "antd";
import { type ReactNode, useMemo } from "react";

import { NotificationsContext } from "./NotificationsContext";

export const NotificationsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [showNotifications, notificationContext] =
    notification.useNotification();

  const value = useMemo(() => ({ showNotifications }), [showNotifications]);

  return (
    <NotificationsContext.Provider value={value}>
      {notificationContext}
      {children}
    </NotificationsContext.Provider>
  );
};
